<template>
    <section class="module">
        <div class="module-header">
            <div class="container module-header-body">
                <div class="font-variable color-1 font-bold module-header-title">{{ $t("Phenotypes", 2) }}</div>
                <UiTooltip :zIndex="68" :width="600" direction="bottom" align="start" :classExtraName="css_normalize.tip">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/images/disease/mark.png" alt="" />
                    <template #content>
                        <div :class="css_normalize.context">{{ $t("PhenotypesDesc1") }}</div>
                        <div :class="css_normalize.context">{{ $t("PhenotypesDesc2") }}</div>
                    </template>
                </UiTooltip>
            </div>
        </div>

        <div class="module-not container text-hint" v-if="!exist">{{ $t("Placeholder.UncollectedData") }}</div>
        <div class="module-container container" v-loading="loading" v-else>
            <!-- 标签提要 -->
            <div class="module-label-body">
                <div class="module-label-title font-bold color-1">{{ $t("Legend") }}：</div>
                <div class="module-label-container">
                    <div class="module-tag-item" v-for="(v1, k1) in variable.labels" :key="k1">
                        <div v-if="v1.color" class="color-lump" :style="{ backgroundColor: `${v1.color}` }"></div>
                        <span>{{ v1.name + ": " + v1.label }}</span>
                    </div>
                    <div class="module-tag-item">
                        <span>(F): {{ $t("Female") }}</span>
                    </div>
                    <div class="module-tag-item">
                        <span>(M): {{ $t("Male") }}</span>
                    </div>
                </div>
                <div class="module-label-container module-label-container2">
                    <div class="module-tag-item">
                        <div class="color-lump" :style="{ backgroundColor: '#CE2424' }"></div>
                        <span>{{ $t("PhenotypeObserved") }}</span>
                    </div>
                    <div class="module-tag-item">
                        <span>N: {{ $t("NormalPhenotype") }}</span>
                    </div>
                    <div class="module-tag-item">
                        <span>{{ $t("RelatedDiseasesCount") }}</span>
                    </div>
                </div>
            </div>

            <!-- 模型表型 -->
            <div class="module-phenotype-body">
                <div class="module-phenotype-header">
                    <div class="module-phenotype-title">
                        <span class="font-bold color-1 title-5">{{ $t("ModelPhenotypes") }}：</span>
                    </div>
                    <UiTooltip class="module-bodys-selector" v-bind="binds.columns" classExtraName="tooltip-selector">
                        <template #default>
                            <div class="module-bodys-feature module-feature-arrow">{{ $t("ShowOrHiddenColumn") }} <UiIcon name="arrow" /></div>
                        </template>
                        <template #content>
                            <template v-for="value in columns" :key="value">
                                <div :class="types.includes(value) ? ['selecotr', 'active'] : ['selecotr']" @click="switchColumn(value)">
                                    <div class="name">{{ value }}</div>
                                    <div class="checkbox"></div>
                                </div>
                            </template>
                        </template>
                    </UiTooltip>
                </div>
                <div class="module-table-container">
                    <tableSwitch2 @spread="methods.switchLine" :option="headerComputed" :data="list_data"></tableSwitch2>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon, UiTooltip } from "various-ui";
//* 私有组件
import tableSwitch2 from "../module-table/index.vue";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css_normalize from "@/assets/style/src/index.module.less";

//* 组合函数
const { refs, variable, methods, computeds, binds } = useComposable();
const { loading, exist, types, columns, list_data } = refs;
const { headerComputed } = computeds;
const { render, hidden, switchColumn } = methods;

//* 组件属性导出
defineExpose({ render, hidden });
</script>

<style lang="less" scoped>
@import "./style/variable.less";
@import "./style/index.less";
</style>
